// A bunch of JS that is translated from user_search.hb
(function () {
    'use strict';

    if (!window.daz) {
        window.daz = {};
    }

    var config = {};
    var dom = {};
    var searchFilterVisibleLimit = 5;

    var filterQueries = [
        'owned',
        'pc',
        'bundle',
        'wishlist',
        'category[]',
        'vendor[]',
        'figure[]',
        'software[]',
        'file_format[]',
        'genre[]'
    ];

    // DOM Ready cause I killed jQuery
    function runWhenDomReady(fn) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', fn);
        } else {
            fn();
        }
    }

    function cacheDom() {
        dom.form = document.getElementById('search-results');
        dom.filterPanel = dom.form && dom.form.querySelector('#category-filter-panel.filter-panel');
        dom.paginationPage = document.getElementById('pagination-page');
        dom.paginationContainer = dom.form && dom.form.querySelector('.pagination_container');
        dom.paginationSpan = dom.form && dom.form.querySelector('.pagination_container .pagination');
        dom.goToPageInput = dom.form && dom.form.querySelector('.go_to_page_input');
        dom.prevBtn = dom.form && dom.form.querySelector('.pagination_container .prev');
        dom.nextBtn = dom.form && dom.form.querySelector('.pagination_container .next');
        dom.backToTop = dom.form && dom.form.querySelector('.pagination_container .back_to_top');
        dom.searchQuery = document.getElementById('search-query');
        dom.searchGuid = document.getElementById('search-guid');
        dom.clearSearch = document.getElementById('clear-main-search');
        dom.searchInputContainer = document.getElementById('search-input-container');
    }

    var searchSubmitPending = false;

    function getSearchLoaderEl() {
        return document.getElementById('search-loading-spinner');
    }

    function showSearchLoader() {
        var el = getSearchLoaderEl();
        if (!el) {
            return;
        }

        el.style.display = 'block';
        el.classList.remove('bs5-d-none');
        el.removeAttribute('hidden');
    }

    function hideSearchLoader() {
        var el = getSearchLoaderEl();
        if (!el) {
            return;
        }

        el.style.display = 'none';
        el.classList.add('bs5-d-none');
    }

    function searchListHasProducts() {
        var list = document.getElementById('search_details_list');
        return !!(list && list.getAttribute('data-products') && list.getAttribute('data-products').trim());
    }

    function searchSlabsRendered() {
        var list = document.getElementById('search_details_list');
        if (!list) {
            return false;
        }

        return !!list.querySelector('li.item, li[data-productid], li[data-failure]');
    }

    function waitForSearchSlabsToFinish(onDone) {
        if (!searchListHasProducts()) {
            onDone();
            return;
        }

        function pollForSlabs() {
            var attempts = 0;
            var sawRequests = false;

            (function check() {
                attempts += 1;

                if (searchSlabsRendered()) {
                    onDone();
                    return;
                }

                if (typeof DazProductSlab !== 'undefined') {
                    if (DazProductSlab.requestCount > 0) {
                        sawRequests = true;
                    }
                    if (sawRequests && DazProductSlab.requestCount <= 0) {
                        onDone();
                        return;
                    }
                }

                if (attempts < 40) {
                    window.setTimeout(check, 250);
                    return;
                }

                onDone();
            })();
        }

        if (daz.filter && typeof daz.filter.onLoad === 'function') {
            daz.filter.onLoad(null, pollForSlabs);
        } else {
            pollForSlabs();
        }
    }

    function submitForm() {
        if (searchSubmitPending) {
            return;
        }

        searchSubmitPending = true;
        showSearchLoader();

        if (dom.form) {
            dom.form.submit();
        }
    }

    function resetPagination() {
        if (dom.paginationPage) {
            dom.paginationPage.value = '1';
        }
    }

    function getCurrPageIndex() {
        return (config.pageCurrent || 1) - 1;
    }

    function scrollToSearchTop() {
        var topHeader = document.getElementById('top-header');
        if (topHeader) {
            window.scrollTo(0, topHeader.offsetTop - 120);
        }
    }

    function syncGoToPageInput() {
        if (!dom.goToPageInput) {
            return;
        }

        var pageNum = String(config.pageCurrent || 1);
        var pageCount = config.pageTotal || 1;

        dom.goToPageInput.min = '1';
        dom.goToPageInput.max = String(pageCount);
        dom.goToPageInput.setAttribute('data-active-page', pageNum);
        dom.goToPageInput.placeholder = pageNum;
        dom.goToPageInput.value = pageNum;
    }

    function buildPagination() {
        if (!dom.paginationSpan || !dom.paginationContainer) {
            return;
        }

        var maxPages = config.pageTotal || 1;
        if (!config.totalResults || maxPages < 1) {
            dom.paginationContainer.style.display = 'none';
            return;
        }

        var currPage = getCurrPageIndex();
        var displayItems = [];

        if (maxPages < 7) {
            for (var i = 0; i < maxPages; i++) {
                displayItems.push(i);
            }
        } else if (currPage < 4) {
            for (var j = 0; j < 5; j++) {
                displayItems.push(j);
            }
            displayItems.push(-1);
            displayItems.push(maxPages - 1);
        } else if (currPage > (maxPages - 4)) {
            displayItems.push(0);
            displayItems.push(-1);
            for (var k = maxPages - 4; k < maxPages; k++) {
                displayItems.push(k);
            }
        } else {
            displayItems.push(0);
            displayItems.push(-1);
            displayItems.push(currPage - 1);
            displayItems.push(currPage);
            displayItems.push(currPage + 1);
            displayItems.push(-1);
            displayItems.push(maxPages - 1);
        }

        var html = '';
        for (var n = 0; n < displayItems.length; n++) {
            if (displayItems[n] === -1) {
                html += '<span class="pagination_blank">...</span>';
            } else {
                var extraClass = displayItems[n] === currPage ? ' active' : '';
                html += '<a class="pagination_page button' + extraClass + '" data-pagenum="' + displayItems[n] + '" href="javascript:void(0);">' + (displayItems[n] + 1) + '</a>';
            }
        }

        dom.paginationSpan.innerHTML = html;

        if (dom.prevBtn) {
            dom.prevBtn.classList.toggle('disabled', currPage === 0);
        }
        if (dom.nextBtn) {
            dom.nextBtn.classList.toggle('disabled', currPage >= maxPages - 1);
        }

        dom.paginationContainer.style.display = 'block';
        syncGoToPageInput();
    }

    function goToPage(pageNum) {
        if (!Number.isInteger(pageNum) || pageNum < 1 || pageNum > (config.pageTotal || 1)) {
            return;
        }

        if (pageNum === config.pageCurrent) {
            return;
        }

        scrollToSearchTop();

        if (dom.paginationPage) {
            dom.paginationPage.value = String(pageNum);
        }

        setQueryId();
        submitForm();
    }

    function submitGoToPageInput() {
        if (!dom.goToPageInput) {
            return;
        }

        var inputVal = String(dom.goToPageInput.value).trim();
        if (!inputVal) {
            syncGoToPageInput();
            return;
        }

        var pageNum = parseInt(inputVal, 10);
        if (!Number.isInteger(pageNum) || pageNum < 1 || pageNum > (config.pageTotal || 1)) {
            syncGoToPageInput();
            return;
        }

        if (String(pageNum) === dom.goToPageInput.getAttribute('data-active-page')) {
            return;
        }

        dom.goToPageInput.setAttribute('data-active-page', String(pageNum));
        goToPage(pageNum);
    }

    function handlePaginationBlankClick() {
        if (!dom.goToPageInput) {
            return;
        }

        var pageNum = String(config.pageCurrent || 1);
        dom.goToPageInput.value = pageNum;
        dom.goToPageInput.focus();
        dom.goToPageInput.select();
    }

    function handleShowHideBackToTop() {
        if (!dom.backToTop) {
            return;
        }

        var topHeader = document.getElementById('top-header');
        if (!topHeader) {
            return;
        }

        dom.backToTop.style.display = window.scrollY > topHeader.offsetTop + 250 ? '' : 'none';
    }

    // Yay, local storage!
    function setQueryId() {
        if (!dom.searchQuery || !dom.searchGuid) {
            return;
        }

        var initial = dom.searchQuery.getAttribute('data-initial') || '';
        if (dom.searchQuery.value !== initial) {
            daz.api.sessionStoragePut('search-guid', null);
            dom.searchGuid.remove();
        } else {
            dom.searchGuid.value = daz.api.sessionStorageGet('search-guid') || dom.searchGuid.value;
        }
    }

    function pagePrevious(event) {
        if (event) {
            event.preventDefault();
        }

        if (config.pageCurrent > 1) {
            goToPage(config.pageCurrent - 1);
        }
    }

    function pageNext(event) {
        if (event) {
            event.preventDefault();
        }

        if (config.pageCurrent < config.pageTotal) {
            goToPage(config.pageCurrent + 1);
        }
    }

    function highlightTopCategory() {
        document.querySelectorAll('.categoryButton').forEach(function (topCategory) {
            var id = topCategory.dataset.identifier;
            if (!id) {
                return;
            }

            var container = document.querySelector('.sub-section[data-parent="' + id + '"]');
            if (!container) {
                return;
            }

            container.querySelectorAll("input[type='checkbox']").forEach(function (checkbox) {
                if (checkbox.checked) {
                    var text = topCategory.querySelector('.button-text');
                    if (text) {
                        text.classList.add('selected');
                    }
                    showSubCategory(id, true);
                }
            });
        });
    }

    function showSubCategory(id, forceShow) {
        var container = document.querySelector('[data-parent="' + id + '"]');
        if (!container) {
            return;
        }

        if (forceShow) {
            container.style.display = '';
        } else {
            container.style.display = container.style.display ? '' : 'none';
        }
    }

    function saveCollapseStatus() {
        if (!dom.filterPanel) {
            return;
        }

        var sections = [];
        dom.filterPanel.querySelectorAll('[data-search-section]').forEach(function (section) {
            var toggle = section.querySelector('.daz-toggler');
            var expanded = toggle && toggle.getAttribute('aria-expanded') === 'true';
            sections.push({
                name: section.getAttribute('data-search-section'),
                collapse: expanded ? 'false' : 'true'
            });
        });

        localStorage.setItem('searchFiltersCollapseStatus', JSON.stringify(sections));
    }

    function loadCollapseStatus() {
        if (!dom.filterPanel) {
            return;
        }

        var stored = localStorage.getItem('searchFiltersCollapseStatus');
        if (stored === null) {
            return;
        }

        var sections = JSON.parse(stored);
        sections.forEach(function (sectionState) {
            var section = dom.filterPanel.querySelector('[data-search-section="' + sectionState.name + '"]');
            if (!section) {
                return;
            }

            var toggle = section.querySelector('.daz-toggler');
            if (!toggle) {
                return;
            }

            var target = toggle.getAttribute('data-toggleelem');
            if (!target) {
                return;
            }

            var targetEl = document.querySelector(target);
            var expanded = sectionState.collapse === 'false';

            toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            if (targetEl) {
                targetEl.style.display = expanded ? '' : 'none';
            }
            toggle.classList.toggle('daztoggle_active', expanded);
        });

        if (daz.productFiltersMobile && daz.productFiltersMobile.syncSectionHeadings) {
            daz.productFiltersMobile.syncSectionHeadings(dom.filterPanel);
        }
    }

    function refreshSearchFilterList(container) {
        if (!container) {
            return;
        }

        var section = container.closest('.product-filter-section');
        if (!section) {
            return;
        }

        var filterGroup = section.getAttribute('data-filter-group');
        var isCategory = filterGroup === 'categories';
        var isFileFormats = filterGroup === 'file-formats';
        var lists = [];

        if (isCategory) {
            var categoryList = container.querySelector('ul.outer-ul');
            if (categoryList) {
                lists.push(categoryList);
            }
        } else if (isFileFormats) {
            lists = Array.prototype.slice.call(
                container.querySelectorAll('ul.file-format-list[data-format-group]')
            );
            if (!lists.length) {
                var flatFileFormatList = container.querySelector('ul.file-format-list');
                if (flatFileFormatList) {
                    lists.push(flatFileFormatList);
                }
            }
        } else {
            var defaultList = container.querySelector('ul.products-list');
            if (!defaultList || defaultList.classList.contains('file-format-list')) {
                return;
            }
            lists.push(defaultList);
        }

        if (!lists.length) {
            return;
        }

        var searchInput = container.querySelector('input.filter_search');
        var searchTerm = searchInput ? searchInput.value.trim().toLowerCase() : '';
        var expanded = container.getAttribute('data-show-all') === 'true';
        var visibleLimit = isFileFormats ? 9999 : searchFilterVisibleLimit;
        var matchedCount = 0;
        var shownCount = 0;

        lists.forEach(function (list) {
            var items = list.querySelectorAll(':scope > li.js-filter-option-container:not(.li-template)');

            items.forEach(function (item) {
                var checked = item.querySelector('input[type="checkbox"]:checked') !== null;
                var matchesSearch = !searchTerm
                    || item.textContent.toLowerCase().indexOf(searchTerm) !== -1
                    || checked;

                if (!matchesSearch) {
                    item.style.display = 'none';
                    item.classList.remove('filter_visible');
                    return;
                }

                matchedCount += 1;

                if (!expanded && shownCount >= visibleLimit && !checked) {
                    item.style.display = 'none';
                    item.classList.remove('filter_visible');
                    return;
                }

                shownCount += 1;
                item.style.display = '';
                item.classList.add('filter_visible');
            });
        });

        if (isFileFormats) {
            return;
        }

        var button = container.querySelector('.filter-show-more');
        if (!button || searchTerm || matchedCount <= visibleLimit) {
            if (button) {
                button.hidden = true;
            }
            return;
        }

        button.hidden = false;
        button.textContent = expanded ? 'Show less' : 'Show more';
    }

    function initSearchCategoryTree() {
        if (!dom.filterPanel) {
            return;
        }

        dom.filterPanel.querySelectorAll('#shopCategoriesContainer .outer-ul input[type=checkbox]:checked').forEach(function (input) {
            var category = input.closest('li.js-filter-option-container.has-children');
            if (!category) {
                return;
            }

            category.classList.add('category-expanded');
            var toggle = category.querySelector(':scope > .category-row > .category-children-toggle');
            if (toggle) {
                toggle.setAttribute('aria-expanded', 'true');
            }
        });
    }

    function syncSearchFilterOptionState(input) {
        var item = input.closest('li.js-filter-option-container');
        if (item) {
            item.classList.toggle('filter-option-selected', input.checked);
        }
    }

    function setFilterIndicatorActive() {
        var params = new URLSearchParams(window.location.search);
        for (var i = 0; i < filterQueries.length; i++) {
            var key = filterQueries[i];
            if (key === 'file_format[]') {
                if (params.getAll('file_format[]').length) {
                    document.querySelectorAll('.filter-indicator').forEach(function (el) {
                        el.setAttribute('data-active', 'true');
                    });
                    break;
                }
                continue;
            }

            if (params.has(key) && params.get(key)) {
                document.querySelectorAll('.filter-indicator').forEach(function (el) {
                    el.setAttribute('data-active', 'true');
                });
                break;
            }
        }
    }

    function markFileFormatPrefsIgnored() {
        if (daz.filter && daz.filter.setSearchFileFormatPrefsIgnore) {
            daz.filter.setSearchFileFormatPrefsIgnore(true);
            if (daz.filter.markFileFormatPreferencesLoaded) {
                daz.filter.markFileFormatPreferencesLoaded();
            }
            return;
        }

        var ignoreInput = document.getElementById('search-ff-ignore');
        if (ignoreInput) {
            ignoreInput.value = '1';
        }
    }

    function clearAllFiltersAndSearch() {
        if (dom.searchInputContainer) {
            var textInput = dom.searchInputContainer.querySelector('input[type="text"]');
            if (textInput) {
                textInput.value = '';
                textInput.focus();
            }
        }

        if (dom.form) {
            dom.form.querySelectorAll('input[type=checkbox]').forEach(function (input) {
                input.checked = false;
            });
        }

        if (daz.filter && daz.filter.setSearchFileFormatPrefsIgnore) {
            daz.filter.setSearchFileFormatPrefsIgnore(false);
        } else {
            var ignoreInput = document.getElementById('search-ff-ignore');
            if (ignoreInput) {
                ignoreInput.value = '';
            }
        }

        if (dom.filterPanel) {
            dom.filterPanel.querySelectorAll('.filter-option-selected').forEach(function (el) {
                el.classList.remove('filter-option-selected');
            });
            dom.filterPanel.querySelectorAll('.collapse-container').forEach(function (el) {
                el.setAttribute('data-show-all', 'false');
            });
        }

        resetPagination();
        setQueryId();
        submitForm();
    }

    function handleFilterCheckboxChange(checkbox) {
        if (!dom.filterPanel || !dom.filterPanel.contains(checkbox)) {
            return;
        }

        syncSearchFilterOptionState(checkbox);
        var container = checkbox.closest('.collapse-container');
        if (container) {
            refreshSearchFilterList(container);
        }

        if (checkbox.closest('[data-filter-group="file-formats"]')) {
            markFileFormatPrefsIgnored();
        }

        resetPagination();
        setQueryId();
        window.setTimeout(submitForm, 0);
    }

    function bindFilterPanelEvents() {
        if (!dom.filterPanel || !dom.form) {
            return;
        }

        dom.filterPanel.addEventListener('click', function (event) {
            if (event.target.closest('.daz-toggler')) {
                window.setTimeout(saveCollapseStatus, 0);
                return;
            }

            if (event.target.matches('[data-filter-group="quick"] input[type=checkbox]')) {
                event.stopPropagation();
                return;
            }

            var categoryToggle = event.target.closest('.category-children-toggle');
            if (categoryToggle) {
                event.preventDefault();
                event.stopPropagation();

                var category = categoryToggle.closest('li.js-filter-option-container');
                if (!category) {
                    return;
                }

                var expanded = !category.classList.contains('category-expanded');
                category.classList.toggle('category-expanded', expanded);
                categoryToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
                categoryToggle.setAttribute('aria-label', expanded ? 'Hide subcategories' : 'Show subcategories');
                return;
            }

            var showMore = event.target.closest('.filter-show-more');
            if (showMore) {
                event.preventDefault();
                var showMoreContainer = showMore.closest('.collapse-container');
                if (!showMoreContainer) {
                    return;
                }
                var isExpanded = showMoreContainer.getAttribute('data-show-all') === 'true';
                showMoreContainer.setAttribute('data-show-all', isExpanded ? 'false' : 'true');
                refreshSearchFilterList(showMoreContainer);
                return;
            }

            var clearBtn = event.target.closest('.search-filter-panel-clear');
            if (clearBtn) {
                dom.filterPanel.querySelectorAll('input[type=checkbox]').forEach(function (input) {
                    input.checked = false;
                });
                dom.filterPanel.querySelectorAll('.filter-option-selected').forEach(function (el) {
                    el.classList.remove('filter-option-selected');
                });
                dom.filterPanel.querySelectorAll('.collapse-container').forEach(function (el) {
                    el.setAttribute('data-show-all', 'false');
                });
                resetPagination();
                setQueryId();
                submitForm();
                return;
            }

            var unselectCategories = event.target.closest('.unselect-categories');
            if (unselectCategories) {
                var categoryContainer = document.getElementById('shopCategoriesContainer');
                if (categoryContainer) {
                    categoryContainer.querySelectorAll('input[type=checkbox]').forEach(function (input) {
                        input.checked = false;
                    });
                }
                resetPagination();
                setQueryId();
                submitForm();
            }
        });

        dom.filterPanel.addEventListener('keyup', function (event) {
            if (event.target.matches('input.filter_search')) {
                refreshSearchFilterList(event.target.closest('.collapse-container'));
            }
        });

        dom.filterPanel.addEventListener('change', function (event) {
            if (event.target.matches('input.filter_search')) {
                refreshSearchFilterList(event.target.closest('.collapse-container'));
            }
        });
    }

    function bindFormEvents() {
        if (!dom.form) {
            return;
        }

        dom.form.addEventListener('submit', setQueryId);

        dom.form.addEventListener('change', function (event) {
            if (event.target.matches('input[type=checkbox]')) {
                handleFilterCheckboxChange(event.target);
                return;
            }

            if (event.target.matches('select')) {
                resetPagination();
                setQueryId();
                submitForm();
            }
        });

        if (dom.paginationSpan) {
            dom.paginationSpan.addEventListener('click', function (event) {
                var blank = event.target.closest('.pagination_blank');
                if (blank) {
                    event.preventDefault();
                    handlePaginationBlankClick();
                    return;
                }

                var pageLink = event.target.closest('.pagination_page');
                if (!pageLink) {
                    return;
                }

                event.preventDefault();
                var pageIndex = parseInt(pageLink.getAttribute('data-pagenum'), 10);
                if (Number.isInteger(pageIndex)) {
                    goToPage(pageIndex + 1);
                }
            });
        }

        if (dom.prevBtn) {
            dom.prevBtn.addEventListener('click', pagePrevious);
        }
        if (dom.nextBtn) {
            dom.nextBtn.addEventListener('click', pageNext);
        }

        if (dom.goToPageInput) {
            dom.goToPageInput.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    submitGoToPageInput();
                }
            });
            dom.goToPageInput.addEventListener('change', submitGoToPageInput);
            dom.goToPageInput.addEventListener('blur', submitGoToPageInput);
        }

        if (dom.backToTop) {
            dom.backToTop.addEventListener('click', function (event) {
                event.preventDefault();
                scrollToSearchTop();
            });
            window.addEventListener('scroll', handleShowHideBackToTop);
            handleShowHideBackToTop();
        }

        var searchIcon = dom.searchInputContainer && dom.searchInputContainer.querySelector('.fd-mag');
        if (searchIcon) {
            searchIcon.style.cursor = 'pointer';
            searchIcon.addEventListener('click', function () {
                resetPagination();
                submitForm();
            });
        }

        if (dom.searchQuery) {
            dom.searchQuery.addEventListener('change', function () {
                resetPagination();
                submitForm();
            });

            dom.searchQuery.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                    resetPagination();
                    submitForm();
                }
            });
        }

        if (dom.clearSearch) {
            dom.clearSearch.addEventListener('click', clearAllFiltersAndSearch);
        }

        document.addEventListener('click', function (event) {
            var slabLink = event.target.closest('#search_details_list a.slab-link');
            if (!slabLink) {
                return;
            }

            var productEl = slabLink.closest('[data-productid]');
            var productId = productEl && productEl.getAttribute('data-productid');
            if (productId && daz.utm) {
                daz.utm.GetSearch(config.queryId, config.keywords, productId);
                daz.utm.Send('click', slabLink.href);
            }
        });
    }

    function init(cfg) {
        config = cfg || {};
        cacheDom();

        if (typeof DazBreadcrumb !== 'undefined') {
            daz.breadcrumb = new DazBreadcrumb();
        }

        buildPagination();

        if (searchListHasProducts()) {
            showSearchLoader();
            waitForSearchSlabsToFinish(hideSearchLoader);
        }

        if (dom.searchGuid) {
            daz.api.sessionStoragePut('search-guid', dom.searchGuid.value);
        }

        if (daz.help && config.searchTerm) {
            daz.help.gtmTrigger({
                event: 'search',
                search_term: config.searchTerm,
                result_count: config.totalResults
            });
        }

        highlightTopCategory();
        setFilterIndicatorActive();

        if (daz.filter && daz.api && daz.api.addCall
            && !daz.filter.loaded.FileFormatPreferences
            && !daz.filter.shouldSkipFileFormatPreferences()) {
            daz.api.addCall('User/info', {
                callbackClass: daz.filter,
                callbackFunc: daz.filter.loadFileFormatPreferences,
                onlyOnce: false
            });
        } else if (daz.filter && daz.filter.shouldSkipFileFormatPreferences()) {
            daz.filter.markFileFormatPreferencesLoaded();
        }

        loadCollapseStatus();
        initSearchCategoryTree();

        if (dom.filterPanel) {
            dom.filterPanel.querySelectorAll('.product-filter-section .collapse-container').forEach(function (container) {
                refreshSearchFilterList(container);
            });
        }

        bindFilterPanelEvents();
        bindFormEvents();

        if (daz.filter && daz.filter.organizeFileFormatGroups) {
            daz.filter.organizeFileFormatGroups();
        }

        if (daz.filter && daz.filter.flushFileFormatFilterTrigger) {
            daz.filter.flushFileFormatFilterTrigger();
        }

        if (daz.filter && daz.filter.updateFileFormatPreferencesUi) {
            daz.filter.updateFileFormatPreferencesUi();
        }
    }

    daz.searchPage = {
        init: function (cfg) {
            runWhenDomReady(function () {
                init(cfg || window.daz.searchPageConfig || {});
            });
        },
        submitForm: submitForm,
        resetPagination: resetPagination,
        setQueryId: setQueryId,
        pagePrevious: pagePrevious,
        pageNext: pageNext,
        goToPage: goToPage,
        buildPagination: buildPagination
    };

    window.submitForm = submitForm;
    window.pagePrevious = pagePrevious;
    window.pageNext = pageNext;
})();
